const initialState = '';

export default (state = initialState, action) => { 
  switch (action.type){
    case 'COMMENT_INVITE':  
      return  action.commentInvite;
    default:
      return state;
  }
};